(function () {
      if (window.__willowZohoSalesIQ) return;
      window.__willowZohoSalesIQ = true;

      var widgetSrc = 'https://salesiq.zohopublic.com/widget?wc=siq32787bca04f4e25d1a403ddcf48a1e9c0277182fb3e9a0efa34ad6c5e3a3a3b5';
      var userOpenedChat = false;
      var openingGraceUntil = 0;
      var closeLockUntil = 0;
      var nativeMissingSince = 0;
      var lastCompactOpen = null;
      var lastChatReady = null;
      var lastSuppressAt = 0;
      var intentResetTimer = 0;
      var scrollGuardTimer = 0;
      var scrollActive = false;
      var chatStateObserver = null;
      var chatStateFrame = 0;
      var chatResizeBound = false;

      function isChatLauncher(target) {
        return !!(target && target.closest && target.closest('#zsiq_float'));
      }

      function beginChatOpenIntent() {
        userOpenedChat = true;
        openingGraceUntil = Date.now() + 1200;
        nativeMissingSince = 0;

        clearTimeout(intentResetTimer);
        /* A cancelled touch must not authorize a later proactive Zoho pop-up. A completed click
           replaces this short timer with a longer one below. */
        intentResetTimer = setTimeout(function () {
          if (chatWindowLooksOpen()) return;
          userOpenedChat = false;
          openingGraceUntil = 0;
          setChatWindowOpen(false);
        }, 1400);
      }

      /* Record intent on pointerdown, but never hide the launcher before Zoho receives click.
         On iOS, changing visibility here cancels the native SalesIQ click sequence. */
      document.addEventListener('pointerdown', function (event) {
        if (event.isTrusted === false || !isChatLauncher(event.target)) return;
        beginChatOpenIntent();
      }, true);

      /* This runs after the launcher click has completed. Applying the compact shell in the next
         frame prevents Zoho's native full-screen wrapper from flashing before its open callback. */
      document.addEventListener('click', function (event) {
        if (event.isTrusted === false || !isChatLauncher(event.target)) return;

        if (!userOpenedChat) beginChatOpenIntent();
        closeLockUntil = 0;
        openingGraceUntil = Date.now() + 9000;
        clearTimeout(intentResetTimer);
        intentResetTimer = setTimeout(function () {
          if (chatWindowLooksOpen()) return;
          userOpenedChat = false;
          openingGraceUntil = 0;
          setChatWindowOpen(false);
        }, 12000);

        requestAnimationFrame(function () {
          if (userOpenedChat) setChatWindowOpen(true);
        });
        setTimeout(scheduleChatStateSync, 80);
        setTimeout(scheduleChatStateSync, 320);
        setTimeout(scheduleChatStateSync, 900);
      }, true);

      function setChatWindowReady(isReady) {
        var ready = !!isReady && window.matchMedia('(max-width: 767px)').matches;
        if (lastChatReady === ready) return;

        lastChatReady = ready;
        document.body.classList.toggle('wv-chat-ready', ready);

        var minimizeButton = document.getElementById('wv-chat-minimize');
        if (minimizeButton) {
          minimizeButton.setAttribute('aria-hidden', ready ? 'false' : 'true');
          minimizeButton.tabIndex = ready ? 0 : -1;
        }
      }

      function setChatWindowOpen(isOpen) {
        var compactOpen = isOpen && window.matchMedia('(max-width: 767px)').matches;

        if (compactOpen) document.body.classList.remove('wv-chat-closing');

        if (lastCompactOpen !== compactOpen) {
          lastCompactOpen = compactOpen;
          document.body.classList.toggle('wv-chat-open', compactOpen);
        }

        if (!compactOpen) {
          setChatWindowReady(false);
          document.documentElement.style.removeProperty('--wv-chat-panel-top');
          return;
        }

        /* Zoho applies its own dimensions first; measure again after our compact rule wins so the
           separate minimise control stays aligned with the native close control. */
        requestAnimationFrame(function () {
          var wrap = document.getElementById('zsiq_chat_wrap');
          if (!wrap) return;
          var rect = wrap.getBoundingClientRect();
          document.documentElement.style.setProperty('--wv-chat-panel-top', Math.max(rect.top, 12) + 'px');
        });
      }

      function chatWindowHasNativeOpenState() {
        var wrap = document.getElementById('zsiq_chat_wrap');
        return !!(
          wrap &&
          wrap.classList.contains('chat-iframe-open') &&
          wrap.querySelector('iframe')
        );
      }

      function chatWindowLooksOpen() {
        var wrap = document.getElementById('zsiq_chat_wrap');
        if (!chatWindowHasNativeOpenState() || !wrap) return false;

        var style = window.getComputedStyle(wrap);
        var rect = wrap.getBoundingClientRect();
        return style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          parseFloat(style.opacity || '1') > 0.05 &&
          rect.width > 120 &&
          rect.height > 180;
      }

      function chatLauncherLooksVisible() {
        var launcher = document.getElementById('zsiq_float');
        if (!launcher) return false;

        var style = window.getComputedStyle(launcher);
        var rect = launcher.getBoundingClientRect();
        return style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          parseFloat(style.opacity || '1') > 0.05 &&
          rect.width > 24 &&
          rect.height > 24;
      }

      function syncChatWindowState() {
        chatStateFrame = 0;

        var now = Date.now();
        var nativeMarkedOpen = chatWindowHasNativeOpenState();
        var nativeOpen = chatWindowLooksOpen();
        var allowOpen = userOpenedChat && now >= closeLockUntil;

        if (nativeOpen && allowOpen) {
          nativeMissingSince = 0;
          clearTimeout(intentResetTimer);
          intentResetTimer = 0;
          setChatWindowOpen(true);
          setChatWindowReady(true);
        }
        else if (allowOpen) {
          /* Zoho replaces its wrapper during reopen. Keep one stable compact state through that
             short gap instead of flashing closed, full-screen, then compact again. */
          if (!nativeMissingSince) nativeMissingSince = now;

          if (now < openingGraceUntil || now - nativeMissingSince < 650) {
            setChatWindowOpen(true);
            setTimeout(scheduleChatStateSync, 180);
          }
          else {
            userOpenedChat = false;
            openingGraceUntil = 0;
            nativeMissingSince = 0;
            setChatWindowOpen(false);
          }
        }
        else {
          nativeMissingSince = 0;
          setChatWindowOpen(false);

          if (nativeMarkedOpen) {
            document.body.classList.add('wv-chat-closing');
            hideUnrequestedWindow(false);
          }
          else {
            document.body.classList.remove('wv-chat-closing');
          }
        }

        /* The back-to-top control only reserves a second row while the actual launcher is visible.
           Offline/disabled chat therefore leaves no empty 46px hole. */
        document.documentElement.classList.toggle(
          'wv-chat-launcher-visible',
          chatLauncherLooksVisible()
        );
      }

      function scheduleChatStateSync() {
        if (chatStateFrame) return;
        chatStateFrame = requestAnimationFrame(syncChatWindowState);
      }

      function watchChatWindow(attempt) {
        /* Observe SalesIQ's stable root, not the current chat wrapper. Zoho replaces that wrapper
           after minimise/reopen; watching the old node is why the second opening fell back to the
           legacy full-screen layout. */
        var root = document.querySelector('[data-id="zsalesiq"]');
        if (!root) {
          if (attempt < 80) {
            setTimeout(function () { watchChatWindow(attempt + 1); }, 250);
          }
          else {
            document.documentElement.classList.remove('wv-chat-launcher-visible');
          }
          return;
        }

        if (chatStateObserver) chatStateObserver.disconnect();
        chatStateObserver = new MutationObserver(scheduleChatStateSync);
        chatStateObserver.observe(root, {
          attributes: true,
          attributeFilter: ['class', 'style', 'aria-hidden'],
          childList: true,
          subtree: true
        });

        if (!chatResizeBound) {
          window.addEventListener('resize', scheduleChatStateSync, { passive: true });
          /* iOS keyboard movement changes visualViewport without always emitting window.resize.
             Re-measure the compact chat shell so its minimise control stays attached to the panel. */
          if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', scheduleChatStateSync, { passive: true });
            window.visualViewport.addEventListener('scroll', scheduleChatStateSync, { passive: true });
          }
          chatResizeBound = true;
        }
        scheduleChatStateSync();
      }

      function markChatMinimized(lockDuration) {
        userOpenedChat = false;
        openingGraceUntil = 0;
        nativeMissingSince = 0;
        closeLockUntil = Date.now() + (lockDuration || 1000);
        clearTimeout(intentResetTimer);
        intentResetTimer = 0;
        document.body.classList.add('wv-chat-closing');
        setChatWindowOpen(false);

        scheduleChatStateSync();
        setTimeout(scheduleChatStateSync, 90);
        setTimeout(scheduleChatStateSync, 260);
        setTimeout(scheduleChatStateSync, 720);
        setTimeout(scheduleChatStateSync, 1300);
      }

      function minimizeChatWindow() {
        /* Paint the closed state first; Zoho can take several frames to remove its native wrapper. */
        markChatMinimized(1200);

        try {
          var salesiq = window.$zoho && window.$zoho.salesiq;
          if (salesiq && salesiq.floatwindow && typeof salesiq.floatwindow.visible === 'function') {
            salesiq.floatwindow.visible('hide');
          }
        }
        catch (error) {
          /* The observer below still restores the launcher when Zoho finishes its own transition. */
        }
      }

      var minimizeButton = document.getElementById('wv-chat-minimize');
      if (minimizeButton) minimizeButton.addEventListener('click', minimizeChatWindow);

      function hideUnrequestedWindow(force) {
        var now = Date.now();
        if (userOpenedChat && now >= closeLockUntil) return;
        if (!force && now - lastSuppressAt < 420) return;
        lastSuppressAt = now;

        try {
          var salesiq = window.$zoho && window.$zoho.salesiq;
          if (salesiq && salesiq.floatwindow && typeof salesiq.floatwindow.visible === 'function') {
            salesiq.floatwindow.visible('hide');
          }
        }
        catch (error) {
          /* SalesIQ may still be initialising; the observer retries if the wrapper stays open. */
        }
      }

      function finishScrollGuard() {
        scrollGuardTimer = 0;
        scrollActive = false;
        document.documentElement.classList.remove('wv-chat-scroll-guard');
      }

      function guardChatDuringScroll() {
        if (!scrollActive) {
          scrollActive = true;
          document.documentElement.classList.add('wv-chat-scroll-guard');
        }

        clearTimeout(scrollGuardTimer);
        scrollGuardTimer = setTimeout(finishScrollGuard, 90);
      }

      /* Scroll covers wheel, touch and keyboard movement. A single passive listener avoids
         duplicate callbacks and accumulated Zoho API timers during the same gesture. */
      window.addEventListener('scroll', guardChatDuringScroll, { passive: true });

      /* Zoho requires visibility APIs to run from its ready handler. Preserve any handler installed
         by the app embed, then make sure the storefront starts with the chat window minimised. */
      window.$zoho = window.$zoho || {};
      window.$zoho.salesiq = window.$zoho.salesiq || {};
      var previousReady = window.$zoho.salesiq.ready;
      window.$zoho.salesiq.ready = function () {
        if (typeof previousReady === 'function') previousReady.apply(this, arguments);

        var salesiq = window.$zoho && window.$zoho.salesiq;
        if (salesiq && salesiq.floatwindow) {
          if (typeof salesiq.floatwindow.open === 'function') {
            salesiq.floatwindow.open(function () {
              if (!userOpenedChat || Date.now() < closeLockUntil) {
                markChatMinimized(900);
                hideUnrequestedWindow(true);
                return;
              }

              openingGraceUntil = Date.now() + 6500;
              nativeMissingSince = 0;
              clearTimeout(intentResetTimer);
              intentResetTimer = 0;
              document.body.classList.remove('wv-chat-closing');
              setChatWindowOpen(true);
              scheduleChatStateSync();
            });
          }
          if (typeof salesiq.floatwindow.minimize === 'function') {
            salesiq.floatwindow.minimize(function () {
              markChatMinimized(900);
            });
          }
          if (typeof salesiq.floatwindow.close === 'function') {
            salesiq.floatwindow.close(function () {
              markChatMinimized(900);
            });
          }
        }

        hideUnrequestedWindow(true);
        watchChatWindow(0);
      };

      function ensureWidget() {
        /* Shopify's app embed wins when enabled; this is only a fallback for this theme. */
        if (document.querySelector('[data-id="zsalesiq"], script[src*="salesiq.zohopublic.com/widget"]')) return;

        window.$zoho = window.$zoho || {};
        window.$zoho.salesiq = window.$zoho.salesiq || {};

        var script = document.createElement('script');
        script.id = 'zsiqscript';
        script.src = widgetSrc;
        script.defer = true;
        document.body.appendChild(script);
      }

      function scheduleWidget() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(ensureWidget, { timeout: 1800 });
        }
        else {
          setTimeout(ensureWidget, 800);
        }
      }

      if (document.readyState === 'complete') {
        scheduleWidget();
        watchChatWindow(0);
      }
      else {
        window.addEventListener('load', function () {
          scheduleWidget();
          watchChatWindow(0);
        }, { once: true });
      }
    })();
